var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsLogoJtbc2Wh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 15,
    viewBox: "0 0 43 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 163286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 277",
    d: "M39.5064 11.9799L42.0018 8.7019C42.6246 7.8785 42.9731 6.88804 43 5.86475C43 4.57221 42.4742 3.3326 41.5382 2.41864C40.6023 1.50467 39.3328 0.991211 38.0092 0.991211C36.6855 0.991211 35.4161 1.50467 34.4802 2.41864C33.5442 3.3326 33.0184 4.57221 33.0184 5.86475V6.22689H36.5895V5.86475C36.5895 5.49687 36.7392 5.14405 37.0055 4.88392C37.2719 4.62379 37.6332 4.47766 38.01 4.47766C38.3867 4.47766 38.748 4.62379 39.0144 4.88392C39.2808 5.14405 39.4304 5.49687 39.4304 5.86475C39.4326 6.21056 39.3635 6.55325 39.2272 6.87244C39.091 7.19163 38.8903 7.48079 38.6373 7.72269L35.3418 11.9799L33.0168 14.979H42.9985V11.9799H39.5064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 278",
    d: "M6.44897 8.87733C6.47586 10.5231 7.16988 12.0912 8.37888 13.2381C9.58789 14.385 11.2132 15.0169 12.8986 14.9955V11.4993C12.1759 11.5087 11.4788 11.2376 10.9606 10.7456C10.4423 10.2536 10.1452 9.58083 10.1345 8.87507V6.47205H12.8986V2.97885H10.1345V0L6.44897 2.97885V8.87733Z",
    fill: "url(#paint0_linear_255_324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 279",
    d: "M30.9131 11.1203C30.4795 11.3712 29.9842 11.502 29.4803 11.4989C29.1184 11.5136 28.7571 11.4566 28.4183 11.3314C28.0794 11.2063 27.77 11.0155 27.5086 10.7706C27.2472 10.5257 27.0392 10.2316 26.8971 9.90623C26.755 9.58082 26.6817 9.23073 26.6817 8.87696C26.6817 8.5232 26.755 8.17308 26.8971 7.84767C27.0392 7.52226 27.2472 7.22827 27.5086 6.98335C27.77 6.73844 28.0794 6.54765 28.4183 6.42248C28.7571 6.29732 29.1184 6.24035 29.4803 6.25499C29.9844 6.25216 30.4798 6.38358 30.9131 6.63512V2.911C30.4425 2.81034 29.9621 2.76005 29.4803 2.76104C28.6432 2.73887 27.8101 2.88074 27.0301 3.17823C26.2501 3.47573 25.5391 3.92284 24.939 4.49315C24.3389 5.06347 23.8619 5.74542 23.5362 6.49875C23.2105 7.25207 23.0427 8.0615 23.0427 8.87921C23.0427 9.69691 23.2105 10.5063 23.5362 11.2597C23.8619 12.013 24.3389 12.6949 24.939 13.2653C25.5391 13.8356 26.2501 14.2827 27.0301 14.5802C27.8101 14.8777 28.6432 15.0195 29.4803 14.9974C29.9621 14.9984 30.4425 14.9481 30.9131 14.8474V11.1203Z",
    fill: "url(#paint1_linear_255_324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 280",
    d: "M23.0315 8.87727C23.0323 7.50018 23.5205 6.16568 24.4136 5.09988C23.4893 4.00563 22.2201 3.24101 20.804 2.92538C19.3879 2.60974 17.9046 2.76086 16.5857 3.35516V0.00292969H12.9001V8.88026C12.9266 10.5261 13.6205 12.0945 14.8296 13.2415C16.0387 14.3884 17.6643 15.0203 19.3498 14.9984C20.3193 15.0016 21.2774 14.7935 22.1541 14.3892C23.0308 13.9849 23.804 13.3946 24.4174 12.6614C23.5218 11.5941 23.0321 10.2571 23.0315 8.87727ZM19.346 11.5015C18.818 11.4867 18.3062 11.3204 17.8744 11.0232C17.4427 10.7261 17.1103 10.3113 16.9186 9.83064C16.7269 9.35002 16.6845 8.82489 16.7967 8.32088C16.9089 7.81687 17.1707 7.35633 17.5495 6.99679C17.9282 6.63725 18.407 6.39465 18.9261 6.29932C19.4452 6.20399 19.9815 6.26016 20.4681 6.46079C20.9547 6.66143 21.37 6.99764 21.662 7.42741C21.954 7.85719 22.1099 8.36148 22.1101 8.87727C22.0986 9.58244 21.8012 10.2544 21.2833 10.7458C20.7653 11.2373 20.0689 11.5082 19.3467 11.4992L19.346 11.5015Z",
    fill: "url(#paint2_linear_255_324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 281",
    d: "M2.76414 8.87749C2.75363 9.58331 2.45658 10.2562 1.93827 10.7482C1.41997 11.2403 0.722815 11.5113 0 11.5017V14.9979C1.68558 15.0199 3.31128 14.3882 4.52042 13.2412C5.72955 12.0942 6.42338 10.5256 6.44966 8.87973V2.979H2.76414V8.87749Z",
    fill: "url(#paint3_linear_255_324)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_324",
    x1: 6.44897,
    y1: 7.49802,
    x2: 12.8986,
    y2: 7.49802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_324",
    x1: 23.0427,
    y1: 8.87921,
    x2: 30.9131,
    y2: 8.87921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_324",
    x1: 12.9001,
    y1: 7.50095,
    x2: 24.4174,
    y2: 7.50095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_255_324",
    x1: 0,
    y1: 8.98873,
    x2: 6.44966,
    y2: 8.98873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsLogoJtbc2Wh);
export default __webpack_public_path__ + "static/media/BS_logo_jtbc2_wh.11f020fdd8524b3dde197235a1e7a328.svg";
export { ForwardRef as ReactComponent };